import Form from "../../components/Form";
import FormField from "../../components/FormField";
import Input from "../../components/Input";
import styles from "./SagCalculator.module.css";

interface Sag {
  sagTravel: number;
  totalTravel: number;
}

const formatPercent = (v: number): string =>
  Intl.NumberFormat(navigator.language, {
    maximumFractionDigits: 1,
  }).format(v * 100);

interface Props {
  viewMode: "fork" | "shock";
}

const SagCalculator = ({ viewMode }: Props) => {
  return (
    <Form<Sag>>
      {(form) => (
        <>
          <form.Field name="sagTravel">
            {(field) => (
              <FormField label="Sag travel" field={field} vertical>
                <Input
                  id={field.name}
                  name={field.name}
                  type="number"
                  required={true}
                  value={field.state.value}
                  onBlur={field.handleBlur}
                  placeholder="0"
                  onChange={(e) => field.handleChange(e.target.valueAsNumber)}
                  hint="mm"
                />
              </FormField>
            )}
          </form.Field>
          <form.Field name="totalTravel">
            {(field) => (
              <FormField
                label={viewMode === "fork" ? "Total travel" : "Shock stroke"}
                field={field}
                vertical
              >
                <Input
                  id={field.name}
                  name={field.name}
                  type="number"
                  required={true}
                  value={field.state.value}
                  onBlur={field.handleBlur}
                  placeholder="0"
                  onChange={(e) => field.handleChange(e.target.valueAsNumber)}
                  hint="mm"
                />
              </FormField>
            )}
          </form.Field>
          <form.Subscribe selector={(state) => [state.values]}>
            {([values]) => (
              <div className={styles.sum}>
                <span className={styles.label}>Sag</span>
                <Input
                  type="text"
                  disabled={true}
                  value={
                    values !== undefined &&
                    values.sagTravel &&
                    values.totalTravel
                      ? formatPercent(values.sagTravel / values.totalTravel)
                      : formatPercent(0)
                  }
                  hint="%"
                />
              </div>
            )}
          </form.Subscribe>
        </>
      )}
    </Form>
  );
};

export default SagCalculator;
